var _mask, _path, _path2, _rect, _circle, _g, _rect2, _rect3, _circle2, _path3, _path4, _path5, _path6, _path7, _path8, _g2, _path9, _ellipse, _path0, _path1, _g3, _path10, _path11, _g4, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 200,
    viewBox: "0 0 272 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_9465_23065",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 40C28 17.9086 45.9086 0 68 0H199C221.091 0 239 17.9086 239 40V200H28V40Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 40C28 17.9086 45.9086 0 68 0H199C221.091 0 239 17.9086 239 40V200H28V40Z",
    fill: "#D4FABC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 40C20 13.4903 41.4903 -8 68 -8H199C225.51 -8 247 13.4903 247 40H231C231 22.3269 216.673 8 199 8H68C50.3269 8 36 22.3269 36 40H20ZM239 200H28H239ZM20 200V40C20 13.4903 41.4903 -8 68 -8V8C50.3269 8 36 22.3269 36 40V200H20ZM199 -8C225.51 -8 247 13.4903 247 40V200H231V40C231 22.3269 216.673 8 199 8V-8Z",
    fill: "black",
    mask: "url(#path-1-inside-1_9465_23065)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 16,
    width: 46,
    height: 14,
    rx: 7,
    fill: "#131119"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 149,
    cy: 23,
    r: 3,
    fill: "#34353B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9465_23065)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 59,
    width: 248,
    height: 82,
    rx: 16,
    fill: "#FFFFFD"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 86,
    width: 119,
    height: 8,
    rx: 4,
    fill: "#D9FCC4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 106,
    width: 75,
    height: 8,
    rx: 4,
    fill: "#D9FCC4"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9465_23065)"
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 100,
    r: 23,
    fill: "url(#paint0_linear_9465_23065)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1161 108.735L51.3777 108.731C47.0236 108.702 43.637 107.419 41.3112 104.913C37.6701 100.991 37.9985 95.5417 38.014 95.312L38.0568 94.6795L38.6921 94.6347C38.6921 94.6347 38.8709 94.6211 39.1856 94.6211C41.3307 94.6211 52.0306 95.2672 52.1122 107.995L52.1161 108.735Z",
    fill: "url(#paint1_linear_9465_23065)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3552 103.368L52.8521 102.859C49.8849 99.8546 48.4436 96.6521 48.568 93.3402C48.762 88.1544 52.7221 84.6443 52.8917 84.499L53.3552 84.0933L53.8205 84.499C53.9901 84.6443 57.9502 88.1544 58.1443 93.3402C58.2686 96.6521 56.8274 99.8546 53.8601 102.859L53.3552 103.368Z",
    fill: "url(#paint2_linear_9465_23065)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0801 108.735L55.0858 108.01C55.1658 95.5365 65.6515 94.9033 67.7517 94.9033C68.0621 94.9033 68.2372 94.9167 68.2372 94.9167L68.858 94.9605L68.9018 95.5804C68.917 95.8055 69.2388 101.144 65.6705 104.989C63.3933 107.445 60.0726 108.702 55.8036 108.731L55.0801 108.735Z",
    fill: "url(#paint3_linear_9465_23065)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.932 138.146V103.396C58.8298 103.389 58.7293 103.389 58.627 103.389H48.4229V138.146H58.932ZM45.8077 138.146H48.4229V103.396H48.3657C44.1371 103.396 40.4249 106.852 40.1199 111.072L38.6901 130.478C38.3765 134.689 41.5809 138.146 45.8077 138.146ZM61.1832 138.146C65.4118 138.146 68.6145 134.689 68.3025 130.469L66.8711 111.065C66.566 106.947 63.022 103.557 58.9251 103.396V138.146H61.1832Z",
    fill: "#FFDE59"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9465_23065",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 102,
    width: 15,
    height: 14
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5059 102.251H69.0131V115.781H55.5059V102.251Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9465_23065)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9465_23065",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 102,
    width: 15,
    height: 14
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2615 102.254C58.5302 102.254 55.5078 105.281 55.5078 109.019C55.5078 112.755 58.5302 115.784 62.2615 115.784C65.991 115.784 69.0151 112.755 69.0151 109.019C69.0151 105.281 65.991 102.254 62.2615 102.254Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9465_23065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.5078 102.254H69.0151V115.784H55.5078V102.254Z",
    fill: "white"
  })))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3888 103.463C59.0613 103.463 57.1758 105.352 57.1758 107.683C57.1758 110.013 59.0613 111.901 61.3888 111.901C63.7145 111.901 65.6001 110.013 65.6001 107.683C65.6001 105.352 63.7145 103.463 61.3888 103.463Z",
    fill: "#3D1F1E"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.6003,
    cy: 105.536,
    rx: 1.4899,
    ry: 1.48987,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9465_23065",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 102,
    width: 14,
    height: 14
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M38 102.344H51.5073V115.874H38V102.344Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9465_23065)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_9465_23065",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 102,
    width: 14,
    height: 14
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7536 102.347C41.0241 102.347 38 105.375 38 109.112C38 112.848 41.0241 115.877 44.7536 115.877C48.4831 115.877 51.5073 112.848 51.5073 109.112C51.5073 105.375 48.4831 102.347 44.7536 102.347Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_9465_23065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 102.347H51.5073V115.877H38V102.347Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_9465_23065",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 103,
    width: 9,
    height: 9
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5586 103.533H49.9812V111.971H41.5586V103.533Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_9465_23065)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_9465_23065",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 103,
    width: 9,
    height: 9
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7718 103.533C43.4461 103.533 41.5605 105.421 41.5605 107.753C41.5605 110.082 43.4461 111.971 45.7718 111.971C48.0976 111.971 49.9831 110.082 49.9831 107.753C49.9831 105.421 48.0976 103.533 45.7718 103.533Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_9465_23065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.5605 103.533H49.9831V111.971H41.5605V103.533Z",
    fill: "#3D1F1E"
  })))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2064 105.535C48.2064 106.358 47.5393 107.025 46.7165 107.025C45.8936 107.025 45.2266 106.358 45.2266 105.535C45.2266 104.712 45.8936 104.045 46.7165 104.045C47.5393 104.045 48.2064 104.712 48.2064 105.535Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9465_23065",
    x: 0,
    y: 59,
    width: 272,
    height: 107,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9465_23065"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9465_23065",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9465_23065",
    x1: 53,
    y1: 77,
    x2: 53,
    y2: 123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF0CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9FBED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9465_23065",
    x1: 45.058,
    y1: 94.6211,
    x2: 45.058,
    y2: 108.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9465_23065",
    x1: 53.3561,
    y1: 84.0933,
    x2: 53.3561,
    y2: 103.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9465_23065",
    x1: 61.9978,
    y1: 94.9033,
    x2: 61.9978,
    y2: 108.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9465_23065"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 77,
    width: 46,
    height: 46,
    rx: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileIcon);
export default __webpack_public_path__ + "static/media/mobile-icon.0c194e34ed24027b663881183173b70f.svg";
export { ForwardRef as ReactComponent };